(() => {
const $f9090eb1ed682c4f$var$domLib = {
    container: '.mcfly-numbers',
    grid: 'div.numbers__grid',
    col: 'div.numbers__col',
    row: 'div.numbers__row',
    number: 'span.numbers__number'
};
const $f9090eb1ed682c4f$var$classNames = {
    showRow: 'show'
};
// Set up Intersection Observer to trigger on 50% element visibility
const $f9090eb1ed682c4f$var$observer = new IntersectionObserver($f9090eb1ed682c4f$var$onScreenEnter, {
    threshold: 0.5
});
document.querySelectorAll($f9090eb1ed682c4f$var$domLib.container).forEach((el)=>{
    // Set up container styles on load and resize
    window.addEventListener('DOMContentLoaded', ()=>{
        $f9090eb1ed682c4f$var$setNumbersSizes(el);
    });
    window.addEventListener('resize', ()=>{
        $f9090eb1ed682c4f$var$setNumbersSizes(el);
    });
    // Start observing the container
    $f9090eb1ed682c4f$var$observer.observe(el);
});
function $f9090eb1ed682c4f$var$onScreenEnter(entries, observer) {
    entries.forEach((entry)=>{
        const el = entry.target;
        if (entry.isIntersecting) {
            $f9090eb1ed682c4f$var$showAllNumbers(el);
            observer.unobserve(el);
        }
    });
}
function $f9090eb1ed682c4f$var$setNumbersSizes(el) {
    const grid = el.querySelector($f9090eb1ed682c4f$var$domLib.grid);
    grid.style.setProperty('--itemWidth', `${grid.clientWidth}px`);
    grid.style.setProperty('--height', `${grid.clientHeight}px`);
    grid.style.setProperty('--width', `${grid.scrollWidth}px`);
    grid.querySelectorAll($f9090eb1ed682c4f$var$domLib.col).forEach((col)=>{
        col.style.setProperty('--offset-left', `${col.offsetLeft * -1}px`);
    });
}
function $f9090eb1ed682c4f$var$showAllNumbers(el) {
    el.querySelectorAll($f9090eb1ed682c4f$var$domLib.row).forEach((row)=>{
        row.classList.add($f9090eb1ed682c4f$var$classNames.showRow);
    });
    el.querySelectorAll($f9090eb1ed682c4f$var$domLib.number).forEach((numberEl)=>{
        const endNumber = parseFloat(numberEl.dataset.end);
        const endNumberIsInt = endNumber % 1 === 0;
        if (numberEl.dataset.start && numberEl.dataset.end) {
            const startNumber = parseFloat(numberEl.dataset.start);
            if (isNaN(endNumber) || isNaN(startNumber)) return;
            const diff = Math.abs(endNumber - startNumber);
            const frameRate = 25;
            const duration = parseFloat(numberEl.closest($f9090eb1ed682c4f$var$domLib.grid).dataset.duration) || 2;
            const totalFrames = Math.round(duration * frameRate);
            const intervalSpeed = 1000 / frameRate;
            let step = diff / totalFrames;
            let i = 1;
            const interval = setInterval(()=>{
                const calculatedNumber = startNumber < endNumber ? startNumber + step * i : startNumber - step * i;
                $f9090eb1ed682c4f$var$printNumberValue($f9090eb1ed682c4f$var$getFormattedNumber(calculatedNumber, endNumberIsInt), numberEl);
                // Clear interval when the animation is done
                i === totalFrames && clearInterval(interval);
                i++;
            }, intervalSpeed);
        } else if (endNumber) $f9090eb1ed682c4f$var$printNumberValue($f9090eb1ed682c4f$var$getFormattedNumber(endNumber, endNumberIsInt), numberEl);
    });
}
function $f9090eb1ed682c4f$var$getFormattedNumber(value, preventDecimals = false) {
    if (preventDecimals) // Return rounded number if it's an integer
    return Math.round(value);
    else // Return rounded number with 2 decimal places if it's a float
    return (Math.round(value * 100) / 100).toLocaleString(navigator.language);
}
function $f9090eb1ed682c4f$var$printNumberValue(value, obj) {
    obj.innerText = value;
    obj.dataset.suffix && (obj.innerText += `${obj.dataset.suffix}`);
}

})();
//# sourceMappingURL=numbers.min.js.map
